import clsx from 'clsx';

/**
 * IconTile — soft tinted square holding an icon.
 *
 * Props:
 *   accent - "brand" (single brand-blue, matches home — prefer this) | "green" |
 *            "amber" | "blue" | "pink" | "purple" | "indigo" | "teal" | "red" | "none" (default)
 *            Each maps to a soft bg + fg color pair. The multi-hue accents
 *            exist only for legacy dashboards; marketing pages use "brand".
 *   size   - 24 | 28 | 32 | 36 (default) | 40 | 44 | 48 | 56 | 64 | 72
 *   shape  - "square" (default, rounded-xl) | "soft" (rounded-md)
 */
const ACCENTS = {
  brand:  'bg-[var(--brand-subtle)] text-brand border border-[var(--brand-border)]',
  green:  'bg-emerald-50 text-emerald-700',
  amber:  'bg-amber-50 text-amber-700',
  blue:   'bg-blue-50 text-blue-700',
  pink:   'bg-pink-50 text-pink-700',
  purple: 'bg-fuchsia-50 text-fuchsia-700',
  indigo: 'bg-indigo-50 text-indigo-700',
  teal:   'bg-teal-50 text-teal-700',
  red:    'bg-red-50 text-red-700',
  none:   'bg-inset text-body',
};

const SIZES = {
  24: 'w-6 h-6',
  28: 'w-7 h-7',
  32: 'w-8 h-8',
  36: 'w-9 h-9',
  40: 'w-10 h-10',
  44: 'w-11 h-11',
  48: 'w-12 h-12',
  56: 'w-14 h-14',
  64: 'w-16 h-16',
  72: 'w-[72px] h-[72px]',
};

const SHAPES = {
  square: 'rounded-xl',
  soft:   'rounded-md',
};

export function IconTile({
  children,
  accent    = 'none',
  size      = 36,
  shape     = 'square',
  className = '',
}) {
  return (
    <span className={clsx(
      'inline-flex items-center justify-center shrink-0',
      ACCENTS[accent] || ACCENTS.none,
      SIZES[size] || SIZES[36],
      SHAPES[shape],
      className,
    )}>
      {children}
    </span>
  );
}
